/**
 * Pure approval-boundary predicates shared by the Local host, Cloud runtime,
 * and renderer. This module deliberately has no Node imports so browser UI can
 * use the same durable-state interpretation as the authoritative runtimes.
 */
function dispatchMatchesReview(dispatch, review) {
    if (!dispatch)
        return false;
    const handoffMatches = dispatch.reviewedHandoffId === undefined || dispatch.reviewedHandoffId === review.handoffId;
    return (handoffMatches &&
        dispatch.reviewedPlanRevision === review.planRevision &&
        dispatch.reviewedPlanHash === review.planHash);
}
function currentPlanWasBuilt(state) {
    const hasBuiltMarker = state.lastBuiltPlanRevision !== undefined || state.lastBuiltPlanHash !== undefined;
    if (!hasBuiltMarker)
        return false;
    if (state.planHash !== undefined && state.lastBuiltPlanHash !== undefined) {
        return state.planHash === state.lastBuiltPlanHash;
    }
    if (state.planRevision !== undefined && state.lastBuiltPlanRevision !== undefined) {
        return state.planRevision === state.lastBuiltPlanRevision;
    }
    // A sparse legacy marker cannot prove that this is an unbuilt plan. Fail
    // closed rather than reopening an approval boundary after a build handoff.
    return true;
}
/**
 * True only while a durable Guided plan is waiting for the user's explicit
 * Start Building action. Chat/activity copy and process-local liveness are not
 * approval evidence.
 */
export function isGuidedPlanAwaitingApproval(stateRaw) {
    if (!stateRaw || typeof stateRaw !== 'object')
        return false;
    const state = stateRaw;
    const review = state.guidedPlanReview;
    if (!review)
        return false;
    if (state.planRevision !== review.planRevision || state.planHash !== review.planHash) {
        return false;
    }
    if (dispatchMatchesReview(state.buildDispatch, review))
        return false;
    return !currentPlanWasBuilt(state);
}
/** A create seed is the only durable state allowed to autofire its prompt. */
export function isFreshCreateAwaitingInitialKickoff(stateRaw) {
    if (!stateRaw || typeof stateRaw !== 'object')
        return false;
    const state = stateRaw;
    return (state.__seed === true &&
        typeof state.status !== 'string' &&
        state.guidedPlanReview === undefined &&
        state.buildDispatch === undefined &&
        state.autoBuild === undefined);
}
//# sourceMappingURL=guided-plan-approval.js.map